import { NgModule } from '@angular/core';
import { JbEmailValidator } from './validators/email.validator';
import { JbDateValidator } from './validators/date.validator';
import { JbEqualValidator } from './validators/equal.validator';
import { JbNumberValidator } from './validators/number.validator';
import { JbRegexValidator } from './validators/regex.validator';
import { JbInputCountriesComponent } from './input/countries/countries.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputBaseComponent } from './input/base/base.component';
import { InputCheckboxComponent } from './input/checkbox/checkbox.component';
import { InputPasswordComponent } from './input/password/password.component';
import { InputSelectComponent } from './input/select/select.component';
import { InputTextareaComponent } from './input/textarea/textarea.component';
import { InputTextComponent } from './input/text/text.component';
import { ObjectToArrayPipe } from './pipes/objectToArray.pipe';
import { JbStepValidator } from './validators/step.validator';
import { JbRequiredCheckboxValidator } from './validators/requiredCheckbox.validator';
import { JbCardCvcValidator } from './validators/cardCvc.validator';
import { JbCardDateValidator } from './validators/cardDate.validator';
import { JbCardNumberValidator } from './validators/cardNumber.validator';
import { JbMinValidator } from './validators/min.validator';
import { JbMaxValidator } from './validators/max.validator';

@NgModule({
  declarations: [
    JbEmailValidator,
    JbDateValidator,
    JbEqualValidator,
    JbNumberValidator,
    JbRegexValidator,
    JbStepValidator,
    JbRequiredCheckboxValidator,
    JbCardCvcValidator,
    JbCardDateValidator,
    JbCardNumberValidator,
    JbMinValidator,
    JbMaxValidator,

    JbInputCountriesComponent,
    InputBaseComponent,
    InputCheckboxComponent,
    InputPasswordComponent,
    InputTextareaComponent,
    InputTextComponent,
    InputSelectComponent,

    ObjectToArrayPipe
  ],
  imports: [
    FormsModule,
    CommonModule
  ],
  providers: [
  ],
  exports: [
    JbEmailValidator,
    JbDateValidator,
    JbEqualValidator,
    JbNumberValidator,
    JbRegexValidator,
    JbStepValidator,
    JbRequiredCheckboxValidator,
    JbCardCvcValidator,
    JbCardDateValidator,
    JbCardNumberValidator,
    JbMinValidator,
    JbMaxValidator,

    JbInputCountriesComponent,
    InputBaseComponent,
    InputCheckboxComponent,
    InputPasswordComponent,
    InputTextareaComponent,
    InputTextComponent,
    InputSelectComponent,

    ObjectToArrayPipe
  ]
})
export class FormModule {
}


// WEBPACK FOOTER //
// ./src/app/form/form.module.ts